<template>
  <div class="player d-flex d-flex--middle">
    <template v-if="!is_buy&&!is_try">
      <span class="lock mr-20"></span>
      <div>请购买后收听</div>
    </template>
    <template v-else>
      <div class="play" @click="play" :id="'play_'+id" :key="'play_'+id" :class="{ pause: !!status }"></div>
      <div class="pl-20 pr-20 d-flex__item"> 
        <ProgressBar
          @handle="onDown"
          @release="onUp"
          @change="handlePro"
          :value.sync="progress"
          :id="'playbar_'+id" 
          :key="'playbar_'+id"
        />
      </div>
      <div class="ml-20 time">{{ lastTime }}</div>
    </template>
  </div>
</template>

<script>
import ProgressBar from "@/components/ProgressBar";
import { Howl } from "howler";
import Modax from "modax";
// function str2sec(str) {
//   const arr = str.split(":").map((o) => +o);
//   return arr[0] * 60 + arr[1];
// }
function fill0(val) {
  return val < 10 ? "0" + val : val;
}

export let CURRENT;
export default {
  components: { ProgressBar },
  props: {
    data: Object,
    is_buy: Number,
    is_try: Number,
    product: Object,
  },
  filters: {
    formatTime(val) {
      if (Number.isNaN(val)) {
        return 0;
      }
      return fill0(Math.floor(val / 60)) + ":" + fill0(val % 60);
    },
  },

  data() {
    return {
      status: 0,
      time: 0,
      progress: 0,
      totalTime: 0,
    };
  },
  computed: {
    lastTime() {
      return this.data.broadcastTime;
      // const per = this.progress / 100;
      // return Math.floor(
      //   (this.totalTime || str2sec(this.data.broadcastTime)) * (1 - per)
      // );
    },
    id(){
      return this.data.id;
    },
  },
  beforeDestroy() {
    this.stop();
    // this._player && this._player.stop((this.totalTime * this.progress) / 100);
  },
  created() {
    let id = 0;
    const fn = () => {
      if (this._player) {
        this.progress = (this._player.seek() / this.totalTime) * 100;
        this.status = this._player.playing() ? 1 : 0;
      }
      if (id) {
        id = requestAnimationFrame(fn);
      }
    };
    this._start = () => {
      this._stop();
      id = requestAnimationFrame(fn);
    };
    this._stop = () => {
      cancelAnimationFrame(id);
      id = 0;
    };
  },
  methods: {
    onDown() {
      this._stop();
    },
    onUp() {
      this.totalTime && this._start();
    },
    handlePro() {
      this.init();
      this.stopOthers();
      if (!this.totalTime) {
        Modax("player")
          .loading()
          .title("缓冲中...")
          .show();
        //未加载
        this._player.load();
        this._player.once("load", () => {
          this._player.seek((this.progress / 100) * this._player.duration());
          this._player.play();
        });
      } else {
        this._player.seek((this.progress / 100) * this._player.duration());
        this._player.play();
      }
    },
    init() {      
      this._player =
        this._player ||
        new Howl({
          html5: true,
          src: this.data.saveurl,
          onload: () => {
            this.totalTime = this._player.duration();
            Modax.close("player");
            // this.$http.post("/wx/playSummary", {
            //   agent: "weixin",
            //   audioVersionId: this.data.id,
            //   memberId: this.$store.state.user.id,
            //   placeId: this.data.id,
            //   scenicId: this.$store.state.id,
            //   type: 1,
            // });
          },
          onplay: () => {
            this.status = 1;
            Modax.close("player");
            this._start();
          },
          onpause: () => {
            this.status = 0;
          },
          onend: () => {
            this.status = 0;
            this.$emit("play-complete");
          },
          onstop: () => {
            this.status = 0;
            this._stop();
          },
        });
    },
    play() {
      if (!this.is_buy&&!this.is_try) {
        Modax()
          .toast(1000)
          .title("请购买后收听")
          .middle()

          .show(true);
        return;
      }
      this.init();
      this.stopOthers();
      if (this._player.playing()) {
        this._player.pause();
        return;
      }
      Modax("player")
        .loading()
        .title("缓冲中...")
        .show();
      this._player.play();
      this.$emit("play");
    },
    stopOthers() {
      if (CURRENT && CURRENT !== this) {
        CURRENT.stop();
      }
      CURRENT = this;
    },

    stop() {
      if (this._player) {
        this._player.stop();
        this._player.seek(0);
      }
      this.progress = 0;
    },
  },
};
</script>

<style lang="scss" scoped>
.lock {
  display: inline-block;
  width: 46px;
  height: 46px;
  background: url(~@/assets/lock.png) no-repeat center;
  background-size: contain;
}
.player {
  padding: 10px 0;
  .play {
    margin-right: 20px;
    width: 46px;
    height: 46px;
    background: url(~@/assets/play.png) no-repeat center;
    background-size: contain;
    &.pause {
      background-image: url(~@/assets/pause.png);
    }
  }
}
</style>
